export default __webpack_public_path__ + "static/media/dva-example.b1be49c7.webp";